module.exports = __webpack_public_path__ + "img/hand-identity.288f9783.png";